import { atom } from 'jotai';
import { sig } from './sig';
import { ctp } from './ctp';

export const sigGeoAtom = atom(sig.features);
export const ctpGeoAtom = atom(ctp.features);

export const dispatchCoordinates = (param: any[]) => {
  let retVal: any[] = [];
  param.forEach((coordinate) => {
    retVal.push(coordinate[0]);
  });

  return retVal;
};
